// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WYSIWYG Rich Text Editor Styles
 * 
 * Custom styles for the Quill editor integration
 */

/* Quill Font Family Definitions */
.ql-font-serif {
  font-family: Georgia, 'Times New Roman', serif;
}

.ql-font-monospace {
  font-family: 'Courier New', Monaco, monospace;
}

.ql-font-arial {
  font-family: Arial, sans-serif;
}

.ql-font-georgia {
  font-family: Georgia, serif;
}

.ql-font-times-new-roman {
  font-family: 'Times New Roman', Times, serif;
}

.ql-font-verdana {
  font-family: Verdana, Geneva, sans-serif;
}

.ql-font-helvetica {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.ql-font-courier-new {
  font-family: 'Courier New', Courier, monospace;
}

.ql-font-trebuchet-ms {
  font-family: 'Trebuchet MS', Helvetica, sans-serif;
}

.ql-font-tahoma {
  font-family: Tahoma, Geneva, sans-serif;
}

.ql-font-impact {
  font-family: Impact, Charcoal, sans-serif;
}

.ql-font-comic-sans-ms {
  font-family: 'Comic Sans MS', cursive, sans-serif;
}

.ql-font-palatino {
  font-family: 'Palatino Linotype', 'Book Antiqua', Palatino, serif;
}

.ql-font-garamond {
  font-family: Garamond, serif;
}

.ql-font-bookman {
  font-family: 'Bookman Old Style', serif;
}

.ql-font-avant-garde {
  font-family: 'Avant Garde', Avantgarde, 'Century Gothic', CenturyGothic, AppleGothic, sans-serif;
}

/* Font picker labels in toolbar */
.ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "Serif";
  font-family: Georgia, serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "Monospace";
  font-family: Monaco, monospace;
}

.ql-picker.ql-font .ql-picker-label[data-value="arial"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="arial"]::before {
  content: "Arial";
  font-family: Arial, sans-serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="georgia"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="georgia"]::before {
  content: "Georgia";
  font-family: Georgia, serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before {
  content: "Times New Roman";
  font-family: 'Times New Roman', serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="verdana"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="verdana"]::before {
  content: "Verdana";
  font-family: Verdana, sans-serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="helvetica"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="helvetica"]::before {
  content: "Helvetica";
  font-family: Helvetica, sans-serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="courier-new"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="courier-new"]::before {
  content: "Courier New";
  font-family: 'Courier New', monospace;
}

.ql-picker.ql-font .ql-picker-label[data-value="trebuchet-ms"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="trebuchet-ms"]::before {
  content: "Trebuchet MS";
  font-family: 'Trebuchet MS', sans-serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="tahoma"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="tahoma"]::before {
  content: "Tahoma";
  font-family: Tahoma, sans-serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="impact"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="impact"]::before {
  content: "Impact";
  font-family: Impact, sans-serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="comic-sans-ms"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="comic-sans-ms"]::before {
  content: "Comic Sans MS";
  font-family: 'Comic Sans MS', cursive;
}

.ql-picker.ql-font .ql-picker-label[data-value="palatino"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="palatino"]::before {
  content: "Palatino";
  font-family: 'Palatino Linotype', Palatino, serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="garamond"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="garamond"]::before {
  content: "Garamond";
  font-family: Garamond, serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="bookman"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="bookman"]::before {
  content: "Bookman";
  font-family: 'Bookman Old Style', serif;
}

.ql-picker.ql-font .ql-picker-label[data-value="avant-garde"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="avant-garde"]::before {
  content: "Avant Garde";
  font-family: 'Avant Garde', sans-serif;
}

/* Default font option */
.ql-picker.ql-font .ql-picker-label::before,
.ql-picker.ql-font .ql-picker-item::before {
  content: "Sans Serif";
}

/* Make font dropdown wider to accommodate longer font names */
.ql-picker.ql-font .ql-picker-label {
  min-width: 120px;
}

.ql-picker.ql-font .ql-picker-options {
  min-width: 150px;
}

/* Font Size Definitions */
.ql-size-8px { font-size: 8px; }
.ql-size-10px { font-size: 10px; }
.ql-size-12px { font-size: 12px; }
.ql-size-14px { font-size: 14px; }
.ql-size-16px { font-size: 16px; }
.ql-size-18px { font-size: 18px; }
.ql-size-20px { font-size: 20px; }
.ql-size-24px { font-size: 24px; }
.ql-size-30px { font-size: 30px; }
.ql-size-36px { font-size: 36px; }
.ql-size-48px { font-size: 48px; }
.ql-size-60px { font-size: 60px; }
.ql-size-72px { font-size: 72px; }
.ql-size-96px { font-size: 96px; }

/* Font size picker labels */
.ql-picker.ql-size .ql-picker-label[data-value="8px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="8px"]::before { content: "8px"; }
.ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="10px"]::before { content: "10px"; }
.ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="12px"]::before { content: "12px"; }
.ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="14px"]::before { content: "14px"; }
.ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="16px"]::before { content: "16px"; }
.ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="18px"]::before { content: "18px"; }
.ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="20px"]::before { content: "20px"; }
.ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="24px"]::before { content: "24px"; }
.ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="30px"]::before { content: "30px"; }
.ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="36px"]::before { content: "36px"; }
.ql-picker.ql-size .ql-picker-label[data-value="48px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="48px"]::before { content: "48px"; }
.ql-picker.ql-size .ql-picker-label[data-value="60px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="60px"]::before { content: "60px"; }
.ql-picker.ql-size .ql-picker-label[data-value="72px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="72px"]::before { content: "72px"; }
.ql-picker.ql-size .ql-picker-label[data-value="96px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="96px"]::before { content: "96px"; }

/* Default size */
.ql-picker.ql-size .ql-picker-label::before,
.ql-picker.ql-size .ql-picker-item::before { content: "Normal"; }

/* Container styles */
.wysiwyg-editor-container {
  position: relative;
  width: 100%;
  cursor: text;
}

.wysiwyg-editor-container:hover {
  border-color: rgba(0, 0, 0, 0.87) !important;
}

/* Override Quill default styles for better Material-UI integration */
.wysiwyg-editor-container .quill {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.wysiwyg-editor-container .ql-toolbar {
  border: none;
  background-color: #f5f5f5;
  border-radius: 4px 4px 0 0;
  padding: 8px;
  margin-bottom: 8px;
  flex-shrink: 0;
}

.wysiwyg-editor-container .ql-container {
  border: none;
  flex: 1;
  overflow: visible; /* Allow tooltip to escape container bounds */
}

/* Ensure link tooltip appears above other content */
.wysiwyg-editor-container .ql-snow .ql-tooltip {
  z-index: 100;
  white-space: nowrap;
}

.wysiwyg-editor-container .ql-editor {
  padding: 0;
  font-size: 16px;
  line-height: 1.6;
}

/* Placeholder styling */
.wysiwyg-editor-container .ql-editor.ql-blank::before {
  color: #999;
  font-style: normal;
  left: 0;
  right: 0;
}

/* Focus state */
.wysiwyg-editor-container .ql-container.ql-focus {
  outline: none;
}

/* Toolbar button hover effects */
.wysiwyg-editor-container .ql-toolbar button:hover {
  background-color: rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}

/* Tooltip styling for toolbar buttons */
.wysiwyg-editor-container .ql-toolbar button[title]:hover::after,
.wysiwyg-editor-container .ql-toolbar .ql-picker[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
}

.wysiwyg-editor-container .ql-toolbar button,
.wysiwyg-editor-container .ql-toolbar .ql-picker {
  position: relative;
}

.wysiwyg-editor-container .ql-toolbar button.ql-active {
  background-color: rgba(25, 118, 210, 0.12);
  color: #1976d2;
}

/* Dropdown styling */
.wysiwyg-editor-container .ql-toolbar .ql-picker-label {
  padding: 4px 8px;
  border-radius: 4px;
}

.wysiwyg-editor-container .ql-toolbar .ql-picker-label:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Color picker styling */
.wysiwyg-editor-container .ql-toolbar .ql-color-picker .ql-picker-label svg,
.wysiwyg-editor-container .ql-toolbar .ql-icon-picker .ql-picker-label svg {
  width: 18px;
  height: 18px;
}

/* Readonly content styling */
.wysiwyg-readonly-content {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Text alignment classes for both editor and readonly content */
.ql-align-center,
.wysiwyg-readonly-content .ql-align-center {
  text-align: center;
}

.ql-align-right,
.wysiwyg-readonly-content .ql-align-right {
  text-align: right;
}

.ql-align-justify,
.wysiwyg-readonly-content .ql-align-justify {
  text-align: justify;
}

/* Ensure alignment works in editor */
.ql-editor .ql-align-center {
  text-align: center;
}

.ql-editor .ql-align-right {
  text-align: right;
}

.ql-editor .ql-align-justify {
  text-align: justify;
}

.wysiwyg-readonly-content h1 { font-size: 2.5em; margin: 0.67em 0; }
.wysiwyg-readonly-content h2 { font-size: 2em; margin: 0.75em 0; }
.wysiwyg-readonly-content h3 { font-size: 1.5em; margin: 0.83em 0; }
.wysiwyg-readonly-content h4 { font-size: 1.17em; margin: 1em 0; }
.wysiwyg-readonly-content h5 { font-size: 1em; margin: 1.33em 0; }
.wysiwyg-readonly-content h6 { font-size: 0.83em; margin: 1.67em 0; }

.wysiwyg-readonly-content p { margin: 0; }
.wysiwyg-readonly-content ul, .wysiwyg-readonly-content ol { padding-left: 2em; }
.wysiwyg-readonly-content blockquote { 
  border-left: 4px solid #ddd;
  padding-left: 1em;
  margin-left: 0;
  color: #666;
}

.wysiwyg-readonly-content pre {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
}

.wysiwyg-readonly-content code {
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}

.wysiwyg-readonly-content img {
  max-width: 100%;
  height: auto;
}

.wysiwyg-readonly-content a {
  color: #1976d2;
  text-decoration: underline;
}

.wysiwyg-readonly-content a:hover {
  text-decoration: none;
}

/* Responsive toolbar */
@media (max-width: 768px) {
  .wysiwyg-editor-container .ql-toolbar {
    padding: 4px;
  }
  
  .wysiwyg-editor-container .ql-toolbar button {
    padding: 3px 6px;
  }
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .wysiwyg-editor-container .ql-toolbar {
    background-color: #333;
    color: #fff;
  }
  
  .wysiwyg-editor-container .ql-toolbar button {
    color: #fff;
  }
  
  .wysiwyg-editor-container .ql-toolbar button:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .wysiwyg-editor-container .ql-toolbar button.ql-active {
    background-color: rgba(33, 150, 243, 0.3);
    color: #64b5f6;
  }
  
  .wysiwyg-editor-container .ql-editor {
    color: #fff;
  }
  
  .wysiwyg-readonly-content code,
  .wysiwyg-readonly-content pre {
    background-color: #444;
    color: #fff;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/page-builder/WYSIWYGRichTextEditor.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,kCAAkC;AAClC;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gGAAgG;AAClG;;AAEA,kCAAkC;AAClC;;EAEE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;;EAEE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;EAEE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;;EAEE,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B,eAAe,cAAc,EAAE;AAC/B,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;AACjC,gBAAgB,eAAe,EAAE;;AAEjC,4BAA4B;AAC5B;+DAC+D,cAAc,EAAE;AAC/E;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;AACjF;gEACgE,eAAe,EAAE;;AAEjF,iBAAiB;AACjB;6CAC6C,iBAAiB,EAAE;;AAEhE,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,qEAAqE;AACrE;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B,gBAAgB,EAAE,gBAAgB,EAAE;AACnE,+BAA+B,cAAc,EAAE,gBAAgB,EAAE;AACjE,+BAA+B,gBAAgB,EAAE,gBAAgB,EAAE;AACnE,+BAA+B,iBAAiB,EAAE,aAAa,EAAE;AACjE,+BAA+B,cAAc,EAAE,gBAAgB,EAAE;AACjE,+BAA+B,iBAAiB,EAAE,gBAAgB,EAAE;;AAEpE,8BAA8B,SAAS,EAAE;AACzC,6DAA6D,iBAAiB,EAAE;AAChF;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,sBAAsB;IACtB,WAAW;EACb;AACF","sourcesContent":["/**\n * WYSIWYG Rich Text Editor Styles\n * \n * Custom styles for the Quill editor integration\n */\n\n/* Quill Font Family Definitions */\n.ql-font-serif {\n  font-family: Georgia, 'Times New Roman', serif;\n}\n\n.ql-font-monospace {\n  font-family: 'Courier New', Monaco, monospace;\n}\n\n.ql-font-arial {\n  font-family: Arial, sans-serif;\n}\n\n.ql-font-georgia {\n  font-family: Georgia, serif;\n}\n\n.ql-font-times-new-roman {\n  font-family: 'Times New Roman', Times, serif;\n}\n\n.ql-font-verdana {\n  font-family: Verdana, Geneva, sans-serif;\n}\n\n.ql-font-helvetica {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\n.ql-font-courier-new {\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.ql-font-trebuchet-ms {\n  font-family: 'Trebuchet MS', Helvetica, sans-serif;\n}\n\n.ql-font-tahoma {\n  font-family: Tahoma, Geneva, sans-serif;\n}\n\n.ql-font-impact {\n  font-family: Impact, Charcoal, sans-serif;\n}\n\n.ql-font-comic-sans-ms {\n  font-family: 'Comic Sans MS', cursive, sans-serif;\n}\n\n.ql-font-palatino {\n  font-family: 'Palatino Linotype', 'Book Antiqua', Palatino, serif;\n}\n\n.ql-font-garamond {\n  font-family: Garamond, serif;\n}\n\n.ql-font-bookman {\n  font-family: 'Bookman Old Style', serif;\n}\n\n.ql-font-avant-garde {\n  font-family: 'Avant Garde', Avantgarde, 'Century Gothic', CenturyGothic, AppleGothic, sans-serif;\n}\n\n/* Font picker labels in toolbar */\n.ql-picker.ql-font .ql-picker-label[data-value=\"serif\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"serif\"]::before {\n  content: \"Serif\";\n  font-family: Georgia, serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"monospace\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"monospace\"]::before {\n  content: \"Monospace\";\n  font-family: Monaco, monospace;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"arial\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"arial\"]::before {\n  content: \"Arial\";\n  font-family: Arial, sans-serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"georgia\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"georgia\"]::before {\n  content: \"Georgia\";\n  font-family: Georgia, serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"times-new-roman\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"times-new-roman\"]::before {\n  content: \"Times New Roman\";\n  font-family: 'Times New Roman', serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"verdana\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"verdana\"]::before {\n  content: \"Verdana\";\n  font-family: Verdana, sans-serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"helvetica\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"helvetica\"]::before {\n  content: \"Helvetica\";\n  font-family: Helvetica, sans-serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"courier-new\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"courier-new\"]::before {\n  content: \"Courier New\";\n  font-family: 'Courier New', monospace;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"trebuchet-ms\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"trebuchet-ms\"]::before {\n  content: \"Trebuchet MS\";\n  font-family: 'Trebuchet MS', sans-serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"tahoma\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"tahoma\"]::before {\n  content: \"Tahoma\";\n  font-family: Tahoma, sans-serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"impact\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"impact\"]::before {\n  content: \"Impact\";\n  font-family: Impact, sans-serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"comic-sans-ms\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"comic-sans-ms\"]::before {\n  content: \"Comic Sans MS\";\n  font-family: 'Comic Sans MS', cursive;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"palatino\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"palatino\"]::before {\n  content: \"Palatino\";\n  font-family: 'Palatino Linotype', Palatino, serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"garamond\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"garamond\"]::before {\n  content: \"Garamond\";\n  font-family: Garamond, serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"bookman\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"bookman\"]::before {\n  content: \"Bookman\";\n  font-family: 'Bookman Old Style', serif;\n}\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"avant-garde\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"avant-garde\"]::before {\n  content: \"Avant Garde\";\n  font-family: 'Avant Garde', sans-serif;\n}\n\n/* Default font option */\n.ql-picker.ql-font .ql-picker-label::before,\n.ql-picker.ql-font .ql-picker-item::before {\n  content: \"Sans Serif\";\n}\n\n/* Make font dropdown wider to accommodate longer font names */\n.ql-picker.ql-font .ql-picker-label {\n  min-width: 120px;\n}\n\n.ql-picker.ql-font .ql-picker-options {\n  min-width: 150px;\n}\n\n/* Font Size Definitions */\n.ql-size-8px { font-size: 8px; }\n.ql-size-10px { font-size: 10px; }\n.ql-size-12px { font-size: 12px; }\n.ql-size-14px { font-size: 14px; }\n.ql-size-16px { font-size: 16px; }\n.ql-size-18px { font-size: 18px; }\n.ql-size-20px { font-size: 20px; }\n.ql-size-24px { font-size: 24px; }\n.ql-size-30px { font-size: 30px; }\n.ql-size-36px { font-size: 36px; }\n.ql-size-48px { font-size: 48px; }\n.ql-size-60px { font-size: 60px; }\n.ql-size-72px { font-size: 72px; }\n.ql-size-96px { font-size: 96px; }\n\n/* Font size picker labels */\n.ql-picker.ql-size .ql-picker-label[data-value=\"8px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"8px\"]::before { content: \"8px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"10px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"10px\"]::before { content: \"10px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"12px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"12px\"]::before { content: \"12px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"14px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"14px\"]::before { content: \"14px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"16px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"16px\"]::before { content: \"16px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"18px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"18px\"]::before { content: \"18px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"20px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"20px\"]::before { content: \"20px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"24px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"24px\"]::before { content: \"24px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"30px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"30px\"]::before { content: \"30px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"36px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"36px\"]::before { content: \"36px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"48px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"48px\"]::before { content: \"48px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"60px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"60px\"]::before { content: \"60px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"72px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"72px\"]::before { content: \"72px\"; }\n.ql-picker.ql-size .ql-picker-label[data-value=\"96px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"96px\"]::before { content: \"96px\"; }\n\n/* Default size */\n.ql-picker.ql-size .ql-picker-label::before,\n.ql-picker.ql-size .ql-picker-item::before { content: \"Normal\"; }\n\n/* Container styles */\n.wysiwyg-editor-container {\n  position: relative;\n  width: 100%;\n  cursor: text;\n}\n\n.wysiwyg-editor-container:hover {\n  border-color: rgba(0, 0, 0, 0.87) !important;\n}\n\n/* Override Quill default styles for better Material-UI integration */\n.wysiwyg-editor-container .quill {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.wysiwyg-editor-container .ql-toolbar {\n  border: none;\n  background-color: #f5f5f5;\n  border-radius: 4px 4px 0 0;\n  padding: 8px;\n  margin-bottom: 8px;\n  flex-shrink: 0;\n}\n\n.wysiwyg-editor-container .ql-container {\n  border: none;\n  flex: 1;\n  overflow: visible; /* Allow tooltip to escape container bounds */\n}\n\n/* Ensure link tooltip appears above other content */\n.wysiwyg-editor-container .ql-snow .ql-tooltip {\n  z-index: 100;\n  white-space: nowrap;\n}\n\n.wysiwyg-editor-container .ql-editor {\n  padding: 0;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n/* Placeholder styling */\n.wysiwyg-editor-container .ql-editor.ql-blank::before {\n  color: #999;\n  font-style: normal;\n  left: 0;\n  right: 0;\n}\n\n/* Focus state */\n.wysiwyg-editor-container .ql-container.ql-focus {\n  outline: none;\n}\n\n/* Toolbar button hover effects */\n.wysiwyg-editor-container .ql-toolbar button:hover {\n  background-color: rgba(0, 0, 0, 0.08);\n  border-radius: 4px;\n}\n\n/* Tooltip styling for toolbar buttons */\n.wysiwyg-editor-container .ql-toolbar button[title]:hover::after,\n.wysiwyg-editor-container .ql-toolbar .ql-picker[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.wysiwyg-editor-container .ql-toolbar button,\n.wysiwyg-editor-container .ql-toolbar .ql-picker {\n  position: relative;\n}\n\n.wysiwyg-editor-container .ql-toolbar button.ql-active {\n  background-color: rgba(25, 118, 210, 0.12);\n  color: #1976d2;\n}\n\n/* Dropdown styling */\n.wysiwyg-editor-container .ql-toolbar .ql-picker-label {\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.wysiwyg-editor-container .ql-toolbar .ql-picker-label:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n/* Color picker styling */\n.wysiwyg-editor-container .ql-toolbar .ql-color-picker .ql-picker-label svg,\n.wysiwyg-editor-container .ql-toolbar .ql-icon-picker .ql-picker-label svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Readonly content styling */\n.wysiwyg-readonly-content {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Text alignment classes for both editor and readonly content */\n.ql-align-center,\n.wysiwyg-readonly-content .ql-align-center {\n  text-align: center;\n}\n\n.ql-align-right,\n.wysiwyg-readonly-content .ql-align-right {\n  text-align: right;\n}\n\n.ql-align-justify,\n.wysiwyg-readonly-content .ql-align-justify {\n  text-align: justify;\n}\n\n/* Ensure alignment works in editor */\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n\n.wysiwyg-readonly-content h1 { font-size: 2.5em; margin: 0.67em 0; }\n.wysiwyg-readonly-content h2 { font-size: 2em; margin: 0.75em 0; }\n.wysiwyg-readonly-content h3 { font-size: 1.5em; margin: 0.83em 0; }\n.wysiwyg-readonly-content h4 { font-size: 1.17em; margin: 1em 0; }\n.wysiwyg-readonly-content h5 { font-size: 1em; margin: 1.33em 0; }\n.wysiwyg-readonly-content h6 { font-size: 0.83em; margin: 1.67em 0; }\n\n.wysiwyg-readonly-content p { margin: 0; }\n.wysiwyg-readonly-content ul, .wysiwyg-readonly-content ol { padding-left: 2em; }\n.wysiwyg-readonly-content blockquote { \n  border-left: 4px solid #ddd;\n  padding-left: 1em;\n  margin-left: 0;\n  color: #666;\n}\n\n.wysiwyg-readonly-content pre {\n  background-color: #f5f5f5;\n  padding: 12px;\n  border-radius: 4px;\n  overflow-x: auto;\n}\n\n.wysiwyg-readonly-content code {\n  background-color: #f5f5f5;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n}\n\n.wysiwyg-readonly-content img {\n  max-width: 100%;\n  height: auto;\n}\n\n.wysiwyg-readonly-content a {\n  color: #1976d2;\n  text-decoration: underline;\n}\n\n.wysiwyg-readonly-content a:hover {\n  text-decoration: none;\n}\n\n/* Responsive toolbar */\n@media (max-width: 768px) {\n  .wysiwyg-editor-container .ql-toolbar {\n    padding: 4px;\n  }\n  \n  .wysiwyg-editor-container .ql-toolbar button {\n    padding: 3px 6px;\n  }\n}\n\n/* Dark mode support (if needed) */\n@media (prefers-color-scheme: dark) {\n  .wysiwyg-editor-container .ql-toolbar {\n    background-color: #333;\n    color: #fff;\n  }\n  \n  .wysiwyg-editor-container .ql-toolbar button {\n    color: #fff;\n  }\n  \n  .wysiwyg-editor-container .ql-toolbar button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  .wysiwyg-editor-container .ql-toolbar button.ql-active {\n    background-color: rgba(33, 150, 243, 0.3);\n    color: #64b5f6;\n  }\n  \n  .wysiwyg-editor-container .ql-editor {\n    color: #fff;\n  }\n  \n  .wysiwyg-readonly-content code,\n  .wysiwyg-readonly-content pre {\n    background-color: #444;\n    color: #fff;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
